'use client';

import { c as _c } from "react/compiler-runtime";
import { FC, lazy, Suspense, useState } from 'react';
import { Dialog, DialogContent } from '@/components/shared/Dialog';
import { BasicProps } from '@/types/common';
import MenuNavigationModal from './MenuNavigationModal';
import { ModalContext } from './ModalContext';
import { ModalKey } from './types';
const ContactUsForm = lazy(() => import('./ContactUsForm'));
const CalendlyModal = lazy(() => import('./CalendlyModal'));
const AboutUsVideo = lazy(() => import('@/components/ModalProvider/AboutUsVideo'));
const BrandQuizModal = lazy(() => import('@/components/ModalProvider/BrandQuizModal'));
const BrandQuizSmallModal = lazy(() => import('@/components/ModalProvider/BrandQuizSmallModal'));
const TeamMemberInfoModal = lazy(() => import('@/components/ModalProvider/TeamMemberInfoModal'));
const DribbleDetailsModal = lazy(() => import('@/components/ModalProvider/DribbleDetailsModal'));
const WebsiteAuditModal = lazy(() => import('@/components/ModalProvider/WebsiteAuditModal'));
const WebsiteAuditFormModal = lazy(() => import('@/components/ModalProvider/WebsiteAuditFormModal'));
const RecommendUsModal = lazy(() => import('@/components/ModalProvider/RecommendUs'));
const BrandingGuidelineSuccessModal = lazy(() => import('@/components/ModalProvider/BrandingGuidelineSuccessModal'));
const LeadMagnetExitModal = lazy(() => import('@/components/ModalProvider/LeadMagnetExitModal'));
const LeadMagnetSuccessModal = lazy(() => import('@/components/ModalProvider/LeadMagnetSuccessModal'));
export const ModalProvider: FC<BasicProps> = t0 => {
  const $ = _c(20);
  const {
    children
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const [modalKey, setModalKey] = useState(null);
  const [modalParams, setModalParams] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = (key, params) => {
      setModalKey(key);
      setModalParams(params);
      setIsOpen(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const openModal = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsOpen(false);
      setModalKey(null);
      setModalParams(null);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const closeModal = t2;
  let t3;
  if ($[2] !== modalKey || $[3] !== modalParams) {
    t3 = modalKey === "CONTACT_US" ? <ContactUsForm {...modalParams} /> : modalKey === "CALENDAR_BOOKING" ? <CalendlyModal /> : modalKey === "ABOUT_US_VIDEO" ? <AboutUsVideo {...modalParams} /> : modalKey === "BRAND_QUIZ" ? <BrandQuizModal {...modalParams} /> : modalKey === "BRAND_QUIZ_SMALL" ? <BrandQuizSmallModal {...modalParams} /> : modalKey === "TEAM_MEMBER_INFO" ? <TeamMemberInfoModal {...modalParams} /> : modalKey === "DRIBBLE_DETAILS" ? <DribbleDetailsModal {...modalParams} /> : modalKey === "WEBSITE_AUDIT" ? <WebsiteAuditModal {...modalParams} /> : modalKey === "WEBSITE_AUDIT_FORM" ? <WebsiteAuditFormModal {...modalParams} /> : modalKey === "RECOMMEND_US" ? <RecommendUsModal {...modalParams} /> : modalKey === "BRANDING_GUIDELINE_SUCCESS" ? <BrandingGuidelineSuccessModal {...modalParams} /> : modalKey === "MENU_NAVIGATION" ? <MenuNavigationModal {...modalParams} /> : modalKey === "LEAD_MAGNET_EXIT" ? <LeadMagnetExitModal {...modalParams} /> : modalKey === "LEAD_MAGNET_SUCCESS" ? <LeadMagnetSuccessModal {...modalParams} /> : null;
    $[2] = modalKey;
    $[3] = modalParams;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const modalContent = t3;
  let t4;
  if ($[5] !== isOpen) {
    t4 = {
      openModal,
      closeModal,
      isOpen
    };
    $[5] = isOpen;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = open => !open && closeModal();
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = modalKey === "MENU_NAVIGATION";
  let t7;
  if ($[8] !== modalContent) {
    t7 = <Suspense fallback={null}>{modalContent}</Suspense>;
    $[8] = modalContent;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6 || $[11] !== t7) {
    t8 = <DialogContent noOverlay={t6}>{t7}</DialogContent>;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== isOpen || $[14] !== t8) {
    t9 = <Dialog open={isOpen} onOpenChange={t5}>{t8}</Dialog>;
    $[13] = isOpen;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== children || $[17] !== t4 || $[18] !== t9) {
    t10 = <ModalContext.Provider value={t4}>{children}{t9}</ModalContext.Provider>;
    $[16] = children;
    $[17] = t4;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
};